import { create } from 'zustand'
import _ from 'lodash';

export const useDataStore = create((set, get) => ({

    inquiryTime: null, //账单查询时间，取账单最后一天的时间

    userInfo: {},
    content: [],
    accountant: {},
    categoryMonthly: {},
    commonTradings: {},
    partyTrading: {},
    riskItems: {},

    setInquiryTime: data => set( state => {
        return {
            "inquiryTime": data
        }
    }),

    setRiskItems: (data) => set(state => {
        return {
            "riskItems": data
        }
    }),

    setAccountant: (data) => set(state => {
        return {
            "accountant": data
        }
    }),

    setCategoryMonthly: (data) => set(state => {
        return {
            "categoryMonthly": data
        }
    }),

    setCommonTradings: (data) => set(state => {
        return {
            "commonTradings": data
        }
    }),

    setPartyTrading: (data) => set(state => {
        return {
            "partyTrading": data
        }
    }),

    setUserInfo: (data) => set(state => {
        return {
            "userInfo": data
        }
    }),

    clearUserInfo: () => set(state => {
        return {
            "userInfo": {}
        }
    }),

    setContent: (data) => set(state => {
        return {
            "content": data
        }
    }),

    clearContent: () => set(state => {
        return {
            "content": []
        }
    }),

    getOrderDetail: (orderId) => {
        let state = get();
        return _.find(state.content, (item) => {
            return item.ID === orderId;
        });
    }
}));